import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const CalculatorIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 22, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.9445 0H3.05548C1.36862 0.00151062 0.00151062 1.36862 0 3.05548V18.9445C0.00151062 20.6314 1.36862 21.9985 3.05548 22H18.9445C20.6314 21.9985 21.9985 20.6314 22 18.9445V3.05548C21.9985 1.36862 20.6314 0.00151062 18.9445 0ZM8.09726 15.5834V11.3055H13.9027V15.5834H8.09726ZM13.9027 16.8055V20.7777H8.09726V16.8055H13.9027ZM13.9027 6.11113V10.0834H8.09726V6.11113H13.9027ZM20.7777 6.11113V10.0834H15.125V6.11113H20.7777ZM6.875 10.0834H1.22226V6.11113H6.875V10.0834ZM1.22226 11.3055H6.875V15.5834H1.22226V11.3055ZM15.125 11.3055H20.7777V15.5834H15.125V11.3055ZM3.05548 1.22226H18.9445C19.9565 1.22327 20.7767 2.04353 20.7777 3.05548V4.88887H1.22226V3.05548C1.22327 2.04353 2.04353 1.22327 3.05548 1.22226ZM1.22226 18.9445V16.8055H6.875V20.7777H3.05548C2.04353 20.7767 1.22327 19.9565 1.22226 18.9445ZM18.9445 20.7777H15.125V16.8055H20.7777V18.9445C20.7767 19.9565 19.9565 20.7767 18.9445 20.7777Z"
        fill="currentColor"
      />
    </svg>
  )
})
CalculatorIcon.displayName = 'CalculatorIcon'
